import ProductShadowBase from "../productShadowBase";
import BabyEntry from "./Entry";

export default class BabyEntryElement extends ProductShadowBase {
  connectedCallback() {
    this.loadAndRender(() => (
      <BabyEntry
        backendHost={this.backendHost ?? undefined}
        appPathPrefix={this.appPathPrefix ?? undefined}
        skipCart={this.skipCart}
        channel={this.channel ?? undefined}
        language={this.language ?? undefined}
      />
    ));
  }
}
